import OrderCancelModal from "./customers-orders/OrderCancelModal";
export default class CustomersOrdersPage {
    constructor() {
        this.page = document.querySelector('.customers-orders.page');
        if (!this.page) {
            return;
        }
        this.initCancelModal();
    }
    initCancelModal() {
        new OrderCancelModal();
    }
}
